angular
  .module('contabilidad.shared')
  .config(Config)

Config.$inject = ['$stateProvider']

function Config ($stateProvider) {
  $stateProvider.state('contabilidad', {
    abstract: true,
    data: {
      title: 'Contabilidad',
    },
    url: '/contabilidad',
    template: '<ui-view></ui-view>',
  })
}




// WEBPACK FOOTER //
// ./src/contabilidad/shared/routes/contabilidad.js